export default {
      id: "information-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#information",
      toString: function () {
        return this.url;
      }
    }